<template>
  <div v-if="Array.isArray(cols)">
    <!-- <el-checkbox v-model="enable"></el-checkbox> -->
    <!-- {{ discount.length }}
      {{ discount }} -->
    <!-- {{ type }} -->
    <!-- {{ data }} -->
    <!-- discount:{{ discount }}
      <hr />
      type:{{ type }} -->

    <div>
      def:{{ def }}
      <van-radio-group v-model="value" @change="onChange">
        <van-row>
          <van-col span="6" v-for="n in cols" :key="n">
            <van-radio :key="n" :name="n">
              {{ n }}
            </van-radio>
          </van-col>
        </van-row>
      </van-radio-group>
    </div>
  </div>
</template>
<style scoped>
.van-radio {
  height: 3rem;
}
.label {
  background-color: #eee;
  margin-right: 1rem;
  padding-left: 1rem;
}
</style>
<script>
export default {
  props: {
    cols: Array,
    def: Number,
    // def: String,
  },
  mounted() {
    // var dc = this.discount;
    // console.log("Discount.monted", dc);
    // if (dc.length > 0) {
    //   this.type = dc[0].id;
    // }
    // this.value = def;
    this.value = this.def;
  },
  data() {
    return {
      value: null,
      parentData: "childData",
      // value: null,
      // enable: false,
      // type: "",
      // columns: [
      //   {
      //     id: "010190",
      //     label: "",
      //     buyQty: 1,
      //     getQty: 1,
      //     rate: 90,
      //   },
      //   {
      //     id: "010180",
      //     label: "",
      //     buyQty: 1,
      //     getQty: 1,
      //     rate: 80,
      //   },
      //   {
      //     id: "010170",
      //     label: "",
      //     buyQty: 1,
      //     getQty: 1,
      //     rate: 70,
      //   },
      // ],
    };
  },
  methods: {
    // getDCText(row) {
    //   var buyQty = Number(row.buyQty);
    //   var getQty = Number(row.getQty);
    //   var rate = Number(row.rate);
    //   if (buyQty == 1) {
    //     // var off = 100 - rate + "%off";
    //     return rate / 10 + "折";
    //   }
    //   if (buyQty == getQty) {
    //     return buyQty + "件" + rate / 10 + "折";
    //   }
    //   if (buyQty == 2) {
    //     if (rate == 0) {
    //       return "買1送1";
    //     }
    //     if (rate == 50) {
    //       return "第" + buyQty + "件半價";
    //     }
    //     return "第" + buyQty + "件" + rate / 10 + "折";
    //   }
    //   if (buyQty == 3) {
    //     if (rate == 0) {
    //       return "買2送1";
    //     }
    //     if (rate == 5) {
    //       return "第" + buyQty + "件半價";
    //     }
    //     return "第" + buyQty + "件" + rate / 10 + "折";
    //   }
    // },
    onChange(value) {
      console.log(value);
      // if (id == undefined) {
      //   return;
      // }
      // if (id == "") {
      //   return this.$emit("change", "");
      // }
      // var find = this.columns.find((r) => r.id == id);
      // find.text = this.getDCText(find);
      this.$emit("change", value);
      // this.$event.target.value =" child value";
      // this.parentData = this.$event.target.value;
      // this.value = value;
    },
  },
};
</script>
